export const ReportsConstants = {
  GET_REPORTS_EMPTY_CHECK_REQUEST: 'REPORTS/GET_REPORTS_EMPTY_CHECK_REQUEST',
  GET_REPORTS_EMPTY_CHECK_SUCCESS: 'REPORTS/GET_REPORTS_EMPTY_CHECK_SUCCESS',
  GET_REPORTS_EMPTY_CHECK_FAILED: 'REPORTS/GET_REPORTS_EMPTY_CHECK_FAILED',
  GET_REPORTS_REQUEST: 'REPORTS/GET_REPORTS_REQUEST',
  GET_REPORTS_SUCCESS: 'REPORTS/GET_REPORTS_SUCCESS',
  GET_REPORTS_FAILED: 'REPORTS/GET_REPORTS_FAILED',
  UPDATE_APPLIED_FILTERS: 'REPORTS/UPDATE_APPLIED_FILTERS',
  UPDATE_SELECTED_TAB: 'REPORTS/UPDATE_SELECTED_TAB',
  REFRESH_TRIGGERED: 'REPORTS/REFRESH_TRIGGERED'
};
